'use client';

import { useState } from 'react';
import { Sheets } from './Sheets';
import { SheetsStackProps } from './Sheets.types';

export const SheetsStack = ({
  sheets,
  microcopy,
  activeIndex: controlledActiveIndex,
  onCloseSheet,
  onOpenSheet,
  className = '',
}: SheetsStackProps) => {
  const [internalActiveIndex, setInternalActiveIndex] = useState<
    number | undefined
  >(undefined);

  const isControlled = controlledActiveIndex !== undefined;
  const activeIndex = isControlled
    ? controlledActiveIndex
    : internalActiveIndex;

  return (
    <div className={className}>
      {sheets.map((sheet, index) => (
        <Sheets
          {...sheet}
          microcopy={microcopy}
          key={index}
          isFirstItem={index === 0}
          open={activeIndex === index}
          onOpenChange={(open) => {
            if (open) {
              if (isControlled) {
                onOpenSheet?.(index);
              } else {
                setInternalActiveIndex(index);
                onOpenSheet?.(index);
              }
            } else {
              if (isControlled) {
                onCloseSheet?.();
              } else {
                setInternalActiveIndex(undefined);
                onCloseSheet?.();
              }
            }
          }}
        >
          {sheet.children}
        </Sheets>
      ))}
    </div>
  );
};
